/* Price format everywhere: "1 299 ₴" -- thousands separated by a non-breaking space, no ".00" decimals, currency symbol on the RIGHT after a non-breaking space.
   Shopify's money format can only be changed per store currency in Admin (Settings > General > Currency formatting), and the hryvnia shown on the Ukraine market uses the platform default "₴1,400.00", so this is done in the browser: every text node that contains a price (a number next to ₴ / zł / PLN / UAH / грн) is rewritten on load and whenever the DOM changes (cart drawer, filters, quick-add modal). Text inside <script>, <style>, <template>, <textarea>, <input> is left alone. */
(function () {
  var NBSP = ' ';
  var SYMBOLS = '₴|zł|PLN|UAH|грн\\.?';
  var NUM = '\\d{1,3}(?:[ ,.\\u00a0\\u202f]\\d{3})+(?:[.,]\\d{1,2})?|\\d+(?:[.,]\\d{1,2})?';
  var RE = new RegExp('(?:(' + SYMBOLS + ')\\s*(' + NUM + ')|(' + NUM + ')\\s*(' + SYMBOLS + '))', 'g');
  var SKIP = { SCRIPT: 1, STYLE: 1, TEMPLATE: 1, TEXTAREA: 1, INPUT: 1, NOSCRIPT: 1 };

  function format(numText, symbol) {
    var t = numText.replace(/[   ]/g, '');
    var dec = '';
    var m = t.match(/[.,](\d{1,2})$/);
    if (m) {
      dec = m[1].length === 1 ? m[1] + '0' : m[1];
      t = t.slice(0, m.index);
    }
    var int = t.replace(/[.,]/g, '');
    if (!/^\d+$/.test(int)) return null;
    int = int.replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
    var out = int + (dec && dec !== '00' ? ',' + dec : '');
    return out + NBSP + symbol.replace(/\.$/, '');
  }

  function fixText(text) {
    return text.replace(RE, function (all, s1, n1, n2, s2) {
      var res = format(n1 || n2, s1 || s2);
      return res === null ? all : res;
    });
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) {
      if (root.parentNode && !SKIP[root.parentNode.nodeName]) fix(root);
      return;
    }
    if (root.nodeType !== 1 || SKIP[root.nodeName]) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        while (p && p !== root.parentNode) {
          if (SKIP[p.nodeName]) return NodeFilter.FILTER_REJECT;
          p = p.parentNode;
        }
        return /(₴|zł|PLN|UAH|грн)/.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    while (w.nextNode()) nodes.push(w.currentNode);
    nodes.forEach(fix);
  }

  function fix(node) {
    var before = node.nodeValue;
    var after = fixText(before);
    if (after !== before) node.nodeValue = after;
  }

  function run() {
    walk(document.body);
  }

  var timer = null;
  var obs = new MutationObserver(function (records) {
    var hit = false;
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      if (r.type === 'characterData') { hit = true; break; }
      if (r.addedNodes && r.addedNodes.length) { hit = true; break; }
    }
    if (!hit) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      obs.disconnect();
      run();
      obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    }, 30);
  });

  function start() {
    run();
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
